export type SurfaceVariant = 'tenant' | 'admin';

export const getSurfaceLabel = (variant: SurfaceVariant) =>
  variant === 'admin' ? 'Internal Only' : 'Tenant';

export const getSurfaceBannerColor = (variant: SurfaceVariant) =>
  variant === 'admin' ? '#B91C1C' : '#1D4ED8';

export const ControlPlaneVariant = {
  primary: '#991B1B',
  accent: '#EF4444',
  background: '#0B0F19',
  focusRing: 'rgba(239, 68, 68, 0.25)',
  light: {
    activeBg: '#FEF2F2',
    border: '#FECACA',
    text: '#7F1D1D',
  },
  dark: {
    activeBg: 'rgba(127, 29, 29, 0.35)',
    border: '#7F1D1D',
    text: '#FCA5A5',
  },
} as const;
